<mat-tab-group [(selectedIndex)]="selectedIndex" (selectedTabChange)="tabChanged($event)">
    <mat-tab>
        <ng-template mat-tab-label>
            Quote
        </ng-template>
        <div class="card-body">
            <app-indicative-quote [quoteDetails]="quoteDetailsForChildTemplates" 
            (quoteDetailsUpdated)="quoteDetailsUpdated($event)"     
            (ProceedFullDetailsBtn)="activateFullDetailsTab()" [staticData]="staticData"></app-indicative-quote>
        </div>
    </mat-tab>
    <mat-tab [disabled]="!full_details_tab" (quoteDetailsUpdated)="quoteDetailsUpdated($event)" >
         <ng-template mat-tab-label>
            Full Details
        </ng-template>
        <div class="card-body">
            <app-full-details [quoteDetails]="quoteDetailsForChildTemplates"
                (quoteDetailsUpdated)="quoteDetailsUpdated($event)"  
                (BackToQuoteDetails)="jumpToIndicativeQuoteDetilsTab()"
                (ProceedToStatementOfFact)="jumpToStatementOfFactTab()"></app-full-details>
        </div>
    </mat-tab>
    <mat-tab [disabled]="!statement_of_facts_tab">
        <ng-template mat-tab-label>
            Statement Of Fact
        </ng-template>
        <div class="card-body">
            <app-fact-statement [quoteDetails]="quoteDetailsForChildTemplates"
                (quoteDetailsUpdated)="quoteDetailsUpdated($event)"  
                (BackToFullDetails)="jumpToFullQuoteDetilsTab()" (ProceedToPayment)="jumpToPayment()">
            </app-fact-statement>
        </div>
    </mat-tab>

    <mat-tab [disabled]="!payment_details">
        <ng-template mat-tab-label>
            Payment Details
        </ng-template>
        <div class="card-body">
            <app-payment [quoteDetails]="quoteDetailsForChildTemplates"
                (quoteDetailsUpdated)="quoteDetailsUpdated($event)"  
                (BackToFactStatement)="jumpToStatementOfFactTab()"
                (UnderWritingSubmission)="jumpToUnderWritingSubmissionTab()"></app-payment>
        </div>
    </mat-tab>
    <mat-tab [disabled]="!submission">
        <ng-template mat-tab-label>
            Submission
        </ng-template>
        <div class="card-body">
            <app-submission (quoteDetailsUpdated)="quoteDetailsUpdated($event)" 
            [quoteDetails]="quoteDetailsForChildTemplates" ></app-submission>
        </div>
    </mat-tab>
</mat-tab-group>